import { t } from "@lingui/core/macro";

const SETTINGS_CTL_UI_TEXT = {
  ui: {
    startMessage: {
      startMessageText: t({
        id: "app.start-message.text",
        message:
          "Please note that while you chat with us you must remain on the website. If you navigate away from the chat or go to another app your connection may be lost.",
      }),
    },
    stopButtonText: {
      simple: t({
        id: "app.stop-button-text.simple",
        message: "End Chat",
      }),
      complex: t({
        id: "app.stop-button-text.complex",
        message: "Need to Leave?",
      }),
    },
    disconnectDisclaimer: t({
      id: "app.disconnect-disclaimer",
      message:
        "Please note that while you chat with us you must remain on the website. If you navigate away from the chat or go to another app your connection may be lost.",
    }),
    cancelButtonText: t({
      id: "app.cancel-button-text",
      message: "Cancel",
    }),
    okButtonText: t({
      id: "app.ok-button-text",
      message: "Ok",
    }),
    chatboxLabelText: t({
      id: "app.chatbox-label-text",
      message: "Type your message here",
    }),
    chatboxTooShortPreText: t({
      id: "app.chatbox-too-short-pre-text",
      message: "Your message is too short. Please increase to at least",
    }),
    chatboxTooShortPostText: t({
      id: "app.chatbox-too-short-post-text",
      message: "characters to send.",
    }),
    chatboxTooLongPreText: t({
      id: "app.chatbox-too-long-pre-text",
      message: "Your message is too long. Please limit to",
    }),
    chatboxTooLongPostText: t({
      id: "app.chatbox-too-long-post-text",
      message: "characters to send.",
    }),
    closeConvoPreText: t({
      id: "app.close-convo-pre-text",
      message: "You've left the chat. For immediate assistance, please call",
    }),
    closeConvoPostText: t({
      id: "app.close-convo-post-text",
      message: "or refresh the page to rejoin the queue.",
    }),
    sendMessageButtonText: t({
      id: "app.send-message-button-text",
      message: "Send",
    }),
    yourConversationHasBeenClosed: t({
      id: "app.your-conversation-has-been-closed",
      message: "Your conversation has been closed.",
    }),
    closeConversationDialog: {
      leaveChat: t({
        id: "app.close-conversation-dialog.leave-chat",
        message: "If you need to leave, message your Crisis Counselor.",
      }),
      leaveChatCompact: t({
        id: "app.close-conversation-dialog.leave-chat-compact",
        message: "Are you sure you wish to end this chat session?",
      }),
    },
  },
  staticPages: {
    generic: {
      description: t({
        id: "app.static-pages.generic.description",
        message:
          "Include a description of the error and clear action the user may take to solve it (or a workaround).",
      }),
    },
    noToken: {
      description: t({
        id: "app.static-pages.no-token.description",
        message:
          "Webchat support is not available through your link. You are brave to reach out, and we're still here for you. Please check your internet connection and try again. If that doesn't work, text STUDENT to 741741.",
      }),
    },
    disconnected: {
      description: t({
        id: "app.static-pages.disconnected.description",
        message: "You have been disconnected. Please get another link.",
      }),
    },
    cannotConnect: {
      description: t({
        id: "app.static-pages.cannot-connect.description",
        message:
          "Webchat support is not available through your link. You are brave to reach out, and we're still here for you. Please check your internet connection and try again. If that doesn't work, text STUDENT to 741741.",
      }),
    },
    openedInAnotherTab: {
      description: t({
        id: "app.static-pages.opened-in-another-tab.description",
        message:
          "Want to chat here instead? \nRefresh this page to continue your conversation.",
      }),
    },
    conversationCleared: {
      description: t({
        id: "app.static-pages.conversation-cleared.description",
        message:
          "You have been disconnected and conversation is cleared. Please get another link.",
      }),
    },
    notFound: {
      description: t({
        id: "app.static-pages.not-found.description",
        message: "We can't find what you're looking for.",
      }),
    },
  },
};

export default SETTINGS_CTL_UI_TEXT;
